import type { FeedbacksTableModalsProps } from '@/components/feedbacks-table/FeedbacksTableModals';
import type {
    FeedbacksTableControllerTableBindings,
    FeedbacksTableControllerValue,
} from '@/components/feedbacks-table/feedbacks-table-controller.types';

type BuildFeedbacksTableControllerBindingsArgs = {
    table: FeedbacksTableControllerTableBindings;
    modals: FeedbacksTableModalsProps;
};

export const buildFeedbacksTableControllerBindings = ({
    table,
    modals,
}: BuildFeedbacksTableControllerBindingsArgs): FeedbacksTableControllerValue => ({
    tableBindings: table,
    modalsBindings: modals,
});
